/* global axios */
import ApiClient from './ApiClient';

class SpamFilterAPI extends ApiClient {
  constructor() {
    super('spam_filter', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(spamKeywords) {
    return axios.put(this.url, {
      spam_filter: {
        spam_keywords: spamKeywords,
      },
    });
  }
}

export default new SpamFilterAPI();
